import React from "react";
import Modal from "components/Modal";
import * as utils from "common/utils";

class PossibleMatchingFarmsModal extends React.Component {
    state = {};

    _toggleSelected = (id) => (e) => {
        this.setState({ selectedFarmId: this.state.selectedFarmId === id ? null : id });
    };

    _onSubmit = (formValues, action) => {
        if (action === "primary") {
            this.props.modal.onConfirm(this.state.selectedFarmId);
        } else {
            this.props.modal.onConfirm(null, this.props.initialValues.newFarm);
        }
    };

    render() {
        const {
            initialValues: { matchingFarms },
            refData = {},
        } = this.props;

        const instructionText = (
            <span>
                There are <b>{matchingFarms.length}</b> farms with similar details to the farm your are trying to create. Are any of these farms the one you are trying to create?
            </span>
        );

        return (
            <Modal title="Possible duplicate?" tertiarySubmitLabel="No" submitLabel="Yes" submitDisabled={!this.state.selectedFarmId} initialValues={matchingFarms} instructionText={instructionText} onSubmit={this._onSubmit}>
                <div className="Grid">
                    <div className="Grid-cell">
                        <h3 className="u-mt-sm">Are any of these farms the one you are trying to create?</h3>
                        <div className="Table u-mt-md" style={{ maxHeight: "400px", overflowY: "auto" }}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Farm name</th>
                                        <th>Description</th>
                                        <th>Address</th>
                                        <th>Region</th>
                                        <th>Ownership</th>
                                        <th className="th--shrink">Match?</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {matchingFarms.map((farm) => {
                                        const isSelected = farm.id === this.state.selectedFarmId;
                                        const region = farm.region ? utils.valueToText(refData.regions, farm.region) : "-";

                                        return (
                                            <tr key={farm.id} className={isSelected ? "is-selected" : ""} onClick={this._toggleSelected(farm.id)}>
                                                <td>{farm.name}</td>
                                                <td>{farm.description}</td>
                                                <td>{farm.address}</td>
                                                <td>{region}</td>
                                                <td>{farm.ownershipStatus}</td>
                                                <td className="u-textCenter">
                                                    <input type="radio" name="selectedFarmId" value={farm.id} defaultChecked={isSelected}></input>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default PossibleMatchingFarmsModal;
